import type { CommandName } from "@nabla/api";
import { loadApi } from "./answers.ts";
import type { Outcome } from "./commands.ts";

type Send = (named: CommandName) => Promise<Outcome<unknown>>;

export async function offered(generation: () => number, name: string, send: Send): Promise<Outcome<unknown>> {
  const session = generation();
  const named = Object.keys((await loadApi())?.commands ?? {}).find((one): one is CommandName => one === name);
  if (generation() !== session) return { ok: false, state: "descartada" };
  if (named !== undefined) return send(named);
  return { ok: false, state: "falhou", error: { kind: "formato", detail: `${name} não é um comando deste app` } };
}
